import { Action } from '@ngrx/store';

import { License, LicensePackage } from '@account-users/account/models/License';
import { AddLicensePayload } from '@account-users/account/models/AddLicensePayload';
import { AccountLicense } from '@account-users/account/models/AccountLicense';

import { LicenseCode } from '@account-users/account/models/LicenseCode';
import {
  AccountState as LicenseState,
  HttpAccountFilters,
} from '@account-users/account/models/IAccount';

export enum LicensesActionTypes {
  FetchAllLicenses = '[Licenses] Fetch All Licenses',
  FetchAllLicensesSuccess = '[Licenses] Fetch All Licenses Success ',
  FetchAllLicensesError = '[Licenses] Fetch All Licenses Error',

  FetchAccountLicensesError = '[Licenses] Fetch Account Licenses Error',

  FetchLicensePackage = '[Licenses] Fetch License Package',
  FetchLicensePackageSuccess = '[Licenses] Fetch Licenses Package Success ',
  FetchLicensePackageError = '[Licenses] Fetch Licenses Package Error',

  PollLicensePackage = '[Licenses] Poll License Package',
  PollLicensePackageSuccess = '[Licenses] Poll License Package Success',
  PollLicensePackageFailure = '[Licenses] Poll License Package Failure',

  UpdateLicenseInPackage = '[Licenses] Update License In Package',
  DisableLicenseNotInPackage = '[Licenses] Disable License Not In Package',

  SetAllowPolling = '[Licenses] Set Allow Polling',
}

export class FetchAllLicenses implements Action {
  readonly type = LicensesActionTypes.FetchAllLicenses;
  constructor(
    public payload: { accountId: string; filters?: HttpAccountFilters },
  ) {}
}

export class FetchAllLicensesError implements Action {
  readonly type = LicensesActionTypes.FetchAllLicensesError;
}

export class FetchAllLicensesSuccess implements Action {
  readonly type = LicensesActionTypes.FetchAllLicensesSuccess;
  constructor(
    public payload: {
      allLicenses: License[];
      accountLicenses: AccountLicense[];
    },
  ) {}
}

export class FetchAccountLicensesError implements Action {
  readonly type = LicensesActionTypes.FetchAccountLicensesError;
}

export class FetchLicensePackage implements Action {
  readonly type = LicensesActionTypes.FetchLicensePackage;
}

export class FetchLicensePackageSuccess implements Action {
  readonly type = LicensesActionTypes.FetchLicensePackageSuccess;
  constructor(public payload: { packages: LicensePackage[] }) {}
}

export class FetchLicensePackageError implements Action {
  readonly type = LicensesActionTypes.FetchLicensePackageError;
}

export class PollLicensePackage implements Action {
  readonly type = LicensesActionTypes.PollLicensePackage;
  constructor(public payload: { accountId: string; license: LicenseCode }) {}
}

export class PollLicensePackageSuccess implements Action {
  readonly type = LicensesActionTypes.PollLicensePackageSuccess;
}

export class PollLicensePackageFailure implements Action {
  readonly type = LicensesActionTypes.PollLicensePackageFailure;
}

export class UpdateLicenseInPackage implements Action {
  readonly type = LicensesActionTypes.UpdateLicenseInPackage;
  constructor(
    public payload: {
      license: LicenseCode;
      licenseState: LicenseState;
    },
  ) {}
}

export class DisableLicenseNotInPackage implements Action {
  readonly type = LicensesActionTypes.DisableLicenseNotInPackage;
  constructor(public payload: { license: LicenseCode }) {}
}

export class SetAllowPolling implements Action {
  readonly type = LicensesActionTypes.SetAllowPolling;
  constructor(public payload: boolean) {}
}

export type LicensesAction =
  | FetchAllLicenses
  | FetchAllLicensesSuccess
  | FetchAllLicensesError
  | FetchAccountLicensesError
  | FetchLicensePackage
  | FetchLicensePackageSuccess
  | FetchLicensePackageError
  | PollLicensePackage
  | PollLicensePackageSuccess
  | PollLicensePackageFailure
  | UpdateLicenseInPackage
  | DisableLicenseNotInPackage
  | SetAllowPolling;
